var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"start-marker"},[_c('IxRes',[_vm._v("frs.dlgCertIntegration.modals.harvestYearHelp.diagram.startMarker")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }